import { Box, Paper, Stack, Typography } from '@mui/material';

const SectionCard = ({ title, subtitle, children }) => (
  <Paper
    sx={{
      p: { xs: 2.25, md: 3 },
      borderRadius: 1,
      border: '1px solid rgba(148, 163, 184, 0.14)',
      boxShadow: '0px 20px 40px rgba(15, 23, 42, 0.05)'
    }}
  >
    <Stack spacing={2.5}>
      <Box>
        <Typography variant="h6">{title}</Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {children}
    </Stack>
  </Paper>
);

export default SectionCard;
